(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/param-handler/assets/javascripts/param-handler.js') >= 0) return;  svs.modules.push('/components/utils/param-handler/assets/javascripts/param-handler.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var matchRegExpString = '=?[^&]*';
var paramHandler = {
  set: function set(_ref) {
    var key = _ref.key,
        value = _ref.value;
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (_typeof(state) !== 'object') {
      throw new TypeError('state must be of type Object');
    }

    var url = window.location.href;
    var regExp = new RegExp("[^=]\\b".concat(key, "\\b").concat(matchRegExpString), 'g');
    var insert = "".concat(key).concat(value ? "=".concat(value) : '');
    var prefix;

    if (url.match(regExp)) {
      var match = url.match(regExp)[0];

      if (match.indexOf('?') === 0) {
        insert = "?".concat(insert);
      } else if (match.indexOf('&') === 0) {
        insert = "&".concat(insert);
      }

      url = url.replace(regExp, insert);
    } else {
      if (url.match(/\?$/)) {
        prefix = '';
      } else if (url.match(/\?/)) {
        prefix = '&';
      } else {
        prefix = '?';
      }

      url = "".concat(url).concat(prefix).concat(insert);
    }

    history.replaceState(state, null, url);
  },
  get: function get(_ref2) {
    var key = _ref2.key;
    var url = window.location.href;
    var regExp = new RegExp("\\b".concat(key, "\\b").concat(matchRegExpString), 'g');
    var value = url.match(regExp);

    if (value && value.length) {
      var split = value[0].split('=');
      value = split.length > 1 ? value[0].split('=')[1] : true;
    }

    return {
      key: key,
      value: value
    };
  },
  remove: function remove(_ref3) {
    var key = _ref3.key;
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (_typeof(state) !== 'object') {
      throw new TypeError('state must be of type Object');
    }

    var url = window.location.href;
    var regExp = new RegExp("\\b".concat(key, "\\b").concat(matchRegExpString), 'g');

    if (url.match(regExp)) {
      var embeddedParamRegExp = new RegExp("&\\b".concat(key, "\\b").concat(matchRegExpString), 'g');
      var firstParamRegExp = new RegExp("\\b".concat(key, "\\b").concat(matchRegExpString, "&"), 'g');

      if (url.match(embeddedParamRegExp)) {
        url = url.replace(embeddedParamRegExp, '');
      } else if (url.match(firstParamRegExp)) {
        url = url.replace(firstParamRegExp, '');
      } else {
        url = url.replace(regExp, '');
      }

      if (url.match(/\?$/g)) {
        url = url.replace(/\?$/g, '');
      }

      history.replaceState(state, null, url);
    }
  }
};
setGlobal('svs.utils.paramHandler', paramHandler);
 })(window);